import React, { useMemo } from 'react';

import { FormikProps } from 'formik';

// components
import {
    CMSDisplayNames,
    CMSType,
    DEFAULT_CMS_TYPE_OPTION,
} from '../../../../models/cms-placeholder.model';

// constants
import { SearchableSelectType } from '../../../inputs/searchableSelect';
import AampeCreateSelectDropdown from '../../../shared/AampeCreateSelectDropdown/AampeCreateSelectDropdown';
import selectConfig from './select-style.config';

interface CMSTypeInputProps {
    formikProps: FormikProps<{
        cms_type: { label: string; value: string };
    }>;
    label?: string;
    menuPortalId?: string;
    isDisabled: boolean;
}

const CMSTypeInput: React.FC<React.PropsWithChildren<CMSTypeInputProps>> = ({
    formikProps,
    label,
    menuPortalId = '',
    isDisabled,
}) => {
    const { values, setFieldValue, setFieldTouched } = formikProps;

    const selectOptions = useMemo<SearchableSelectType[]>(() => {
        const result = Object.keys(CMSType).map((type) => ({
            value: type,
            label: CMSDisplayNames[type as CMSType],
        }));
        result.push(DEFAULT_CMS_TYPE_OPTION);
        return result;
    }, []);

    const handleChange = (name: string, value: SearchableSelectType) => {
        if (!value.value) {
            setFieldValue('cms_type', DEFAULT_CMS_TYPE_OPTION); // Set the default none value when clear is clicked
        } else {
            setFieldValue('cms_type', value);
        }
    };

    const menuPortal = document.getElementById(menuPortalId);

    return (
        <AampeCreateSelectDropdown
            label={label}
            options={selectOptions}
            name={'cms_type'}
            value={values.cms_type}
            onChange={handleChange as any}
            onBlur={setFieldTouched}
            placeholder={'Select CMS type'}
            menuPortalTarget={menuPortal}
            customStyle={selectConfig}
            isDisabled={isDisabled}
        />
    );
};

export default CMSTypeInput;
